import { useEffect } from 'react';

/**
 * Custom hook to handle input focus and cursor positioning when editing starts
 */
export const useInputFocus = (
  isEditingActive: boolean,
  text: string,
  setEditText: (text: string) => void,
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement | null>
) => {
  useEffect(() => {
    if (!isEditingActive || !inputRef.current) return;

    const textWithSpace = text.endsWith(' ') ? text : text + ' ';
    setEditText(textWithSpace);

    inputRef.current.focus();

    // Use requestAnimationFrame for better timing
    requestAnimationFrame(() => {
      if (inputRef.current) {
        const length = textWithSpace.length;
        inputRef.current.setSelectionRange(length, length);
      }
    });
  }, [isEditingActive, text, setEditText, inputRef]);
};
